import steps from "./form_json/en/basic_lead_form.json";

export const LEAD_STEP = steps.find((s) => s.key === "lead_details");
export const FIN_STEP = steps.find((s) => s.key === "financier_selection");
export const PROPERTY_STEP = steps.find((s) => s.key === "property_loan_details");
export const CUSTOMER_STEP = steps.find((s) => s.key === "customer_coborrower_details");

export default steps;
